export default "__VITE_ASSET__Dixxg5qQ__"